import React from 'react';
import { SYSTEM, USER } from '../../../permissions';
import { pathJoin } from '../../../services/api';
import { useHasPermission } from '../../../services/auth/auth';
import { useParams } from '../../../services/routing/useRouteInfo';
import { AddNote } from '../../shared/actions/actionButtons';
import { ViewLayout } from '../../shared/cardLayouts/viewLayout';
import { ArchivedUserCard } from '../../shared/cards/archivedUserCard';
import { AutoSizeCard } from '../../shared/cards/autoSizeCard';
import { NoteCard } from '../../shared/cards/noteCard';
import { UserPopoutCard } from '../../shared/cards/userPopoutCard';
import { LoadText } from '../../shared/load/loadText';
import { View } from '../../shared/view/view';
import { SystemAuthorizationsList } from './authorizedSystemList';

export const UserView = () => {
    let { id } = useParams();
    const canReadSystems = useHasPermission([SYSTEM.READ]);

    return (
        <View
            id={id}
            resourceName='User'
            nameFunction={(r) => r?.displayName}
            restEndpoint='users/'
            listUrl='users/'
            readPermissions={[USER.READ]}
            writePermissions={[USER.WRITE]}
            actions={[AddNote]}>
            {({ loading, data, canWrite, canRead, refreshData }) => (
                <ViewLayout>
                    {data.note && (
                        <NoteCard
                            columns={3}
                            restEndpoint={pathJoin('users', id)}
                            refreshData={refreshData}
                            title='User Note'
                            editButton={canWrite}
                            deleteButton={canWrite}>
                            {data.note}
                        </NoteCard>
                    )}

                    <UserPopoutCard
                        data={{
                            displayName: loading ? (
                                <LoadText />
                            ) : (
                                data?.displayName ?? 'None'
                            ),
                            mail: data?.mail,
                            mobilePhone: data?.mobilePhone,
                            authorizedForSystemCount:
                                data?.authorizedForSystemCount ?? 0,
                            id: data?.id,
                            hasProfilePhoto: data?.hasProfilePhoto,
                        }}
                        showEmail={true}
                        showPhone={true}
                        showAuthorizedSystems={true}
                        action={<></>}
                    />

                    {canReadSystems && (
                        <AutoSizeCard columns={2}>
                            <h1>System Access</h1>
                            <SystemAuthorizationsList
                                isArchived={data.archived}
                                refreshData={() => {
                                    refreshData(); /*refreshAuditLogData();*/
                                }}
                                scope={id}
                            />
                        </AutoSizeCard>
                    )}

                    {data.archived && <ArchivedUserCard />}
                </ViewLayout>
            )}
        </View>
    );
};
